export enum FicheIncidentGraviteEnum {
  FAIBLE=0,
  MOYENNE=1,
  HAUTE=2
}